import React from 'react';
import { Check, Remove } from '@mui/icons-material';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import * as S from './GTCheckBox.styles';

interface GTCheckBoxProps {
  onClick: () => void;
  isChecked: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
  dataCy?: string;
}

export const GTCheckBox: React.FC<GTCheckBoxProps> = ({
  onClick,
  isChecked,
  indeterminate = false,
  disabled,
  style,
  dataCy = 'select-control',
}) => {
  return (
    <S.Div
      $isChecked={isChecked}
      $indeterminate={indeterminate}
      $disabled={disabled}
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) {
          onClick();
          mpEvent(MPEvents.TableCheckboxClick, {
            value: isChecked ? 'unchecked' : 'checked',
          });
        }
      }}
      data-cy={dataCy}
      className="gt-checkbox"
    >
      {isChecked && <Check />}
      {indeterminate && !isChecked && <Remove />}
    </S.Div>
  );
};
